module.exports = __webpack_public_path__ + "static/profile-pic-a66fbb1cb3071bbc0997bcf02fd38160.jpg";